import './checkbox.scss'
import clsx from 'clsx'
import { CheckmarkBlueSVGIcon } from '@/shared/assets'

export interface CheckboxProps
    extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
    className?: string
    onClick?: () => void
    disableOpacity?: boolean
    sizeVariant?: 'default' | 'big'
    variant?: 'green' | 'default' | 'error'
    checkmarkColor?: string
}

export const Checkbox = ({
    checked,
    onChange,
    className,
    onClick,
    disabled,
    id,
    disableOpacity,
    sizeVariant = 'default',
    variant = 'default',
    checkmarkColor = '',
    ...props
}: CheckboxProps) => {
    return (
        <label
            className={clsx('checkbox', className, {
                'checkbox--disabled': disabled,
                'checkbox--green': variant === 'green',
                'checkbox--error': variant === 'error',
                disableOpacity,
            })}
            style={
                {
                    '--checkbox-size':
                        sizeVariant === 'big' ? `20px` : undefined,
                    '--checkmark-size':
                        sizeVariant === 'big' ? `22px` : undefined,
                } as React.CSSProperties
            }
            onClick={() => {
                onClick && onClick()
            }}
        >
            <input
                id={id}
                type="checkbox"
                checked={checked}
                onChange={onChange}
                disabled={disabled}
                className="checkbox__input"
                {...props}
            />
            <span className="checkbox__box"></span>
            <CheckmarkBlueSVGIcon
                className={clsx('checkbox__icon', checkmarkColor)}
            />
        </label>
    )
}
